/**
 * Moves Store
 *
 * UI state for the Moves palette. The applicable moves themselves come from the
 * engine (src/lib/moves) via a MoveContext; this store only remembers the last
 * applied move so the palette can show its explanation strip (handwriting voice
 * sentence + theory label + undo / hear-it / hear-the-old-way) after an apply.
 */

import { create } from 'zustand';
import type { Chord } from '@/types';

export interface LastAppliedMove {
  moveId: string;
  /** Handwriting voice, lowercase, one sentence. */
  explanation: string;
  /** Short theory label, e.g. "modal mixture · IV → iv". */
  theoryLabel: string;
  /** ids of the chords the move changed or inserted. */
  affectedIds: string[];
  /** The progression exactly as it was before the move — for "hear the old way". */
  beforeChords: Chord[];
}

interface MovesState {
  lastApplied: LastAppliedMove | null;
  setLastApplied: (last: LastAppliedMove) => void;
  clearLastApplied: () => void;
}

export const useMovesStore = create<MovesState>((set) => ({
  lastApplied: null,
  setLastApplied: (last) => set({ lastApplied: last }),
  clearLastApplied: () => set({ lastApplied: null }),
}));
